import React from "react";

const Dot = ({ icon, isActive }) => {
  return (
    <div
      className={`flex aspect-square h-42 flex-col items-center justify-center rounded-full p-8 ${
        isActive ? "bg-brand-primary text-white" : "bg-gray-20 text-gray-500"
      }`}
    >
      {icon}
    </div>
  );
};

export default Dot;
